import { X } from '@hungryroot/icons';
import {
  Paragraph,
  Heading,
  Button,
  ModalOverlay,
  ModalContent,
} from '@hungryroot/ramen';

import styles from './FutureOrdersWillChangeModal.module.css';

interface FutureOrdersWillChangeModalProps {
  subscriptionWarningCopy: string | undefined;
  testid?: string;
  toggleDialog: () => void;
  onConfirmUpdate: () => void;
}

export const FutureOrdersWillChangeModal = ({
  subscriptionWarningCopy,
  testid = 'futureOrdersModal',
  toggleDialog,
  onConfirmUpdate,
}: FutureOrdersWillChangeModalProps) => {
  return (
    <div data-testid={testid}>
      <ModalOverlay
        isOpen={true}
        className={styles.overlay}
        onDismiss={toggleDialog}
      >
        <ModalContent
          ariaLabel="Future Orders Will Change Modal"
          className={styles['dialog-content']}
          data-testid={`${testid}-modal-content`}
        >
          <button
            data-testid={`${testid}-close`}
            onClick={toggleDialog}
            className={styles.close}
          >
            <X />
          </button>

          <div data-testid={`${testid}-modal-body`} className={styles.modal}>
            <Heading variant="H5">Heads up!</Heading>
            <Paragraph>
              All future deliveries will change to reflect your new preferences.{' '}
              {subscriptionWarningCopy && (
                <span>{subscriptionWarningCopy} </span>
              )}
              Changes will not apply to recently processed deliveries.
            </Paragraph>
            <Button
              style="muted"
              prominence="primary"
              size="small"
              onClick={onConfirmUpdate}
              textPrimary="OK"
              testid={`${testid}-confirm-button`}
              className={styles['modal-button']}
            />
          </div>
        </ModalContent>
      </ModalOverlay>
    </div>
  );
};
